/**
 * Lazy route registration for the question-bank feature (Plan 02-06 Task 3).
 *
 * QuestionBankPage hosts both the import dropzone (UI-SPEC §Surface 2 Upload
 * phase) and the existing-questions browser. i18n preload keeps DE/ES + the
 * "question-bank" namespace valid on first navigation (BUG-003).
 */
import { lazy } from "react";

export const QuestionBankRoute = lazy(() =>
  import("@/features/question-bank/QuestionBankPage").then((m) => ({
    default: m.QuestionBankPage,
  })),
);

/** Plan 02-10b Task 2 — bank-question edit surface (content_admin only). */
export const QuestionEditRoute = lazy(() =>
  import("@/features/question-bank/QuestionEditPage").then((m) => ({
    default: m.QuestionEditPage,
  })),
);
